import React from 'react';
import FaqBannerSC from './faq-banner.styled';
import { HeadingTwo, BodyText } from '../typography';
import Button from '../ui/button';

import { FormattedMessage } from 'react-intl';
import dlt from '../../utils/default-lang';

const FaqBanner = () => {
  const onEmailClick = () => {
    window.location = 'mailto:info@wishmaker.sk';
  };
  return (
    <FaqBannerSC>
      <div className="left-wrap">
        <HeadingTwo className="white left-wrap--main-headline">
          <FormattedMessage id="faq_banner_headline" defaultMessage={dlt['faq_banner_headline']} />
        </HeadingTwo>
      </div>
      <div className="right-wrap">
        <BodyText className="grey bolder">
          <FormattedMessage id="global_contact_us" defaultMessage={dlt['global_contact_us']} />
        </BodyText>
        <Button type="LINK" onClick={() => onEmailClick()}>
          info@wishmaker.sk
        </Button>
      </div>
    </FaqBannerSC>
  );
};

export default FaqBanner;
